import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';
// import { CameraPreview } from '@ionic-native/camera-preview/ngx';

import { V2RoutingModule } from './v2-routing.module';
import { V2Page } from './v2.page';
import { V2HomePageModule } from './v2-home/v2-home.module';
import { V2TopBarModule } from '../shared/components/v2/v2-top-bar/v2-top-bar.module';
import { SideCartModule } from '../shared/components/v2/side-cart/side-cart.module';
import { CameraPageModule } from '../shared/components/v2/camera-page/camera-page.module';
import { V2ItemPageModule } from '../shared/components/v2/v2-item/v2-item.module';
import { TopBarDataResolver } from '../shared/resolvers/v2-home.resolver';
import { CardapioPageModule } from './cardapio/cardapio.module';
import { ContaPageModule } from './conta/conta.module';
import { RatingPageModule } from './rating/rating.module';
import { MesaPageModule } from './mesa/mesa.module';
import { GalleryPageModule } from './gallery/gallery.module';
import { UserInfoRequestZapPageModule } from './finishing-pages/user-info-request-zap/user-info-request-zap.module';
import { UserInfoRequestCardPageModule } from './finishing-pages/user-info-request-card/user-info-request-card.module';
import { DialogScannerPageModule } from '../pages/dialog-scanner-page/dialog-scanner-page.module';
import { ComandaScanPageModule } from './finishing-pages/comanda-scan/comanda-scan.module';
import { UserInfoDrivePageModule } from './finishing-pages/user-info-drive/user-info-drive.module';
import { V2TopBarComponent } from '../shared/components/v2/v2-top-bar/v2-top-bar.component';
import { V2ItemPage } from '../shared/components/v2/v2-item/v2-item.page';
import { SideCartComponent } from '../shared/components/v2/side-cart/side-cart.component';
import { TablePagePageModule } from './finishing-pages/table-page/table-page.module';
import { UserInfoRequestConsumoPageModule } from './finishing-pages/user-info-request-consumo/user-info-request-consumo.module';
import { UserInfoRequestGestorPageModule } from './finishing-pages/user-info-request-gestor/user-info-request-gestor.module';



@NgModule({
  declarations: [V2Page],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    V2RoutingModule,
    CameraPageModule,
    CardapioPageModule,
    ComandaScanPageModule,
    ContaPageModule,
    DialogScannerPageModule,
    GalleryPageModule,
    MesaPageModule,
    RatingPageModule,
    UserInfoDrivePageModule,
    UserInfoRequestCardPageModule,
    UserInfoRequestZapPageModule,
    UserInfoRequestGestorPageModule,
    UserInfoRequestConsumoPageModule,
    SideCartModule,
    V2HomePageModule,
    V2TopBarModule,
    V2ItemPageModule,
    TablePagePageModule
    // CameraPageModule
  ],
  providers: [
    // CameraPreview
    // TopBarDataResolver
    V2TopBarComponent,
    V2ItemPage,
    SideCartComponent
  ]
})
export class V2Module { }
